import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import {
  IconFilter,
  FilterSelectComponent,
} from 'nallian-shared-ui/lib/components/semantic-filter-components';
import lookupService from 'nallian-shared-ui/lib/hoc/lookupService';
import { addParametersToUri } from 'nallian-shared-ui/lib/lib/uri';
import apiRoutes from '../../../../../app/api/routes';
import { communityMemberOptionMap } from '../../../helpers/communityMemberOptionMap';

const CommunityMemberFilter = ({ filterName, filterCommunityMembersFetch }) => {
  const memberOptions = useMemo(
    () => (filterCommunityMembersFetch.value || []).map(communityMemberOptionMap),
    [filterCommunityMembersFetch.value]
  );

  return (
    <IconFilter
      hasApplyButton
      name={filterName}
      position="bottom right"
      placement="bottom-end"
      as={FilterSelectComponent}
      options={memberOptions}
    />
  );
};

CommunityMemberFilter.propTypes = {
  filterName: PropTypes.string.isRequired,
  filterCommunityMembersFetch: PropTypes.object.isRequired,
};

export default compose(
  lookupService(({ communityId }) => ({
    resource: 'filterCommunityMembers',
    url: addParametersToUri(apiRoutes.communityMembers(communityId), { page: 1, pageSize: 100 }),
  }))
)(CommunityMemberFilter);
